<template>
  <div class="container" id="goods-edit">
    <!-- 面包屑导航 -->
    <breadcrumb-top :breadcrumbConfig="dataList"></breadcrumb-top>
    <!-- 面包屑导航 -->
    <!-- 查询 -->
    <div class="content c-top">
      <breadcrumb-search :breadcrumbSearch="searchList"></breadcrumb-search>
      <el-form
        :model="infoForm"
        :rules="infoRules"
        ref="infoForm"
        label-width="100px"
        class="info-form"
      >
        <el-form-item label="商品分类">
          <div class="goods-category-edit">
            <span>{{ categoryArrStr }}</span>
          </div>
        </el-form-item>
        <el-form-item label="商品类型" prop="goodsType">
          <el-radio-group
            v-model="infoForm.goodsType"
            :disabled="currentPageStatus !== 'add'"
          >
            <el-radio
              v-for="item in goods_types"
              :key="item.dictId"
              :value="item.dictId"
              :label="item.dictName"
              :name="item.dictId"
            ></el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="商品名称" prop="name">
          <el-input
            style="width: 442px"
            v-model="infoForm.name"
            placeholder="请输入商品名称"
            maxlength="30"
            show-word-limit
            clearable
            disabled
          ></el-input>
        </el-form-item>
        <el-form-item label="分类标签">
          <div v-if="infoForm.tagNameList&&infoForm.tagNameList.length!=0" style="display: flex; flex-wrap: wrap;margin-top: 4px;">
            <div v-for="(item, index) in infoForm.tagNameList" :key="index" style="
            margin-right:24px;
            height: 32px;
            background: #E9ECFE;
            opacity: 1;
            border-radius: 3px;
            font-size: 14px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            line-height: 32px;
            color: #303033;
            text-align: center;
            padding-left: 8px;
            padding-right:8px
            ">{{
            item
          }}</div>
          </div>
          <div v-else>无</div>
          
        </el-form-item>
        <el-form-item label="商品编码" v-if="infoForm.goodsNo" class="goods-no">
          <el-input
            v-model="infoForm.goodsNo"
            :disabled="true"
            style="width: 442px"
          ></el-input>
        </el-form-item>
        <el-form-item label="平台商品编号" class="goods-no">
          <el-input
            v-model="infoForm.platformGoodsNo"
            disabled
            style="width: 442px"
          ></el-input>
        </el-form-item>
        <el-form-item label="商品标签">
          <el-input
            disabled
            style="width: 442px"
            v-model="infoForm.tag"
            placeholder="请输入商品标签"
            maxlength="6"
            show-word-limit
          ></el-input>
        </el-form-item>
        <div
          style="
            width: 674px;
            height: 0px;
            border: 1px dashed #ebebfa;
            opacity: 1;
            margin-bottom: 6px;
          "
        ></div>
        <el-form-item label="类目属性">
          <label slot="label"
            ><span
              style="
                font-size: 14px;
                font-family: Microsoft YaHei;
                font-weight: bold;
                line-height: 0px;
                color: #303033;
              "
              >类目属性</span
            ></label
          >
          <div class="content attr" style="padding: 0px 0px !important">
            <div class="attr-content" style="background-color: white">
              <template v-for="(item, index) in goodsAttrData">
                <h5 style="color: #303033">商品属性/{{ item.name }}</h5>
                <div class="attr-list">
                  <form-filed
                    :formconfig="item.formconfig"
                    :formData="item.formData"
                    @formDataval="dialogClick"
                    :ref="'formAttr' + item.id"
                  />
                </div>
              </template>
            </div>
          </div>
        </el-form-item>
      </el-form>
    </div>

    <div class="content image-text-form" v-if="infoForm.goodsType != '赠品'">
      <h3>运费设置</h3>
      <el-form label-width="100px" v-if="detail">
        <!-- <el-form-item label="运费设置">
          <el-select style="width: 40%" v-model="infoForm.brandId"> </el-select>
        </el-form-item> -->
        <el-form-item label="">
          <!-- <el-radio-group v-model="radio">
            <el-radio :label="3">按件数</el-radio>
            <el-radio :label="6">按重量</el-radio>
          </el-radio-group> -->
          <number
            v-if="detail.calculType == 1"
            :isEdit="false"
            :tableData="tableData"
            :freight="detail.freight"
            :baseNumber="detail.baseNumber"
            :addNum="detail.addNum"
            :addPrice="detail.addPrice"
          ></number>
          <weight
            v-if="detail.calculType == 2"
            :isEdit="false"
            :tableData="tableData"
            :freight="detail.freight"
            :baseNumber="detail.baseNumber"
            :addNum="detail.addNum"
            :addPrice="detail.addPrice"
          ></weight>
          <free-delivery
            v-if="tableDataF.length != 0"
            :tableData="tableDataF"
            style="margin-top: 10px"
            :isEdit="false"
          ></free-delivery>
        </el-form-item>
      </el-form>
    </div>
    <div class="content image-text-form">
      <h3>图文信息</h3>
      <el-form label-width="100px">
        <el-form-item label="商品图片(0/10)">
          <label slot="label"
            ><span style="color: red">*</span>商品图片({{
              this.fileList.length
            }}/10)</label
          >
          <div style="display: flex">
            <div
              class="itemI"
              style="margin-left: 8px"
              v-for="(item, index) in fileList"
              :key="item + index"
            >
              <el-image
                style="width: 108px; height: 108px; border-radius: 6px"
                :src="item.url"
              ></el-image>
              <span
                v-if="index == 0"
                style="
                  color: #2d46ee;
                  position: absolute;
                  top: 100px;
                  left: 10px;
                "
                >（商品主图）</span
              >
            </div>
          </div>

          <!-- <upload-picture
            :limit="10"
            :list="fileList"
            @changeImage="changeImage"
          /> -->
          <!--          <upload-picture></upload-picture>-->
        </el-form-item>
        <el-form-item label="">
          <div
            style="
              font-size: 12px;
              font-family: Microsoft YaHei;
              font-weight: 400;
              line-height: 16px;
              color: #909099;
            "
          >
            图片尺寸：建议上传750px*750px，每张上传大小不得超过2M,支持jpg、jpeg、png格式
          </div>
        </el-form-item>
        <el-form-item label="商品详情">
          <label slot="label"><span style="color: red">*</span>商品详情</label>
          <!--          <editor :init="editorInit" v-model="infoForm.detail" api-key="70xmc76i21jyu8ob8fmf4dtcjfpz0atkne1ttkxppmzsu230"/>-->
          <!-- <tinymce v-model="infoForm.details"></tinymce> -->
          <quill-editor
            v-model="infoForm.details"
            ref="myQuillEditor"
            :options="editorOption"
            class="editor"
            disabled
          ></quill-editor>
          <div class="bottom" style="display: none">
            <el-upload
              class="centerImg"
              :action="' '"
              list-type="picture-card"
              :auto-upload="false"
              :on-change="handleAvatarChangeIcon"
              ref="uploadicon"
            >
            </el-upload>
          </div>
        </el-form-item>
      </el-form>
    </div>
    <div class="content" id="sku-content">
      <div style="display: flex">
        <h3>价格库存</h3>
        <div
          v-if="infoForm.goodsType != '赠品'"
          style="
            color: #2d46ee;
            margin-left: 14px;
            font-size: 14px;
            line-height: 30px;
          "
        >
          平台服务商佣金比例：{{ serverRate }}%
        </div>
        <div
          v-if="infoForm.goodsType != '赠品'"
          style="
            color: #2d46ee;
            margin-left: 18px;
            font-size: 14px;
            line-height: 30px;
          "
        >
          默认自返佣金比例：{{ userRate }}%
        </div>
        <div
          v-if="infoForm.goodsType != '赠品'"
          style="
            color: #2d46ee;
            margin-left: 18px;
            font-size: 14px;
            line-height: 30px;
          "
        >
          默认一级佣金比例：{{ firstNormalCommProp }}%
        </div>
      </div>

      <div class="sku-box">
        <div class="sku-title"></div>
        <div class="sku-content-box">
          <div class="goods-sale-list">
            <SkuForm
              ref="skuForm"
              :source-attribute="skuFormConfig.sourceAttribute"
              :attribute.sync="skuFormConfig.attribute"
              :sku.sync="skuFormConfig.sku"
              :disabled="skuFormConfig.showForm"
              :structure="skuFormConfig.structure"
            >
              <template #image="slotImg">
                <el-image
                  style="width: 64px; height: 64px; border-radius: 6px"
                  :src="slotImg.row.image"
                ></el-image>
              </template>
              <template #weight="slotProps">
                {{ slotProps.row.weight ? slotProps.row.weight : "- -" }}
              </template>
              <template #marketPrice="slotProps">
                {{
                  slotProps.row.marketPrice ? slotProps.row.marketPrice : "- -"
                }}
              </template>
              <template #retailPrice="slotProps">
                {{
                  slotProps.row.retailPrice ? slotProps.row.retailPrice : "- -"
                }}
              </template>
              <template #settlementPrice="slotProps">
                {{
                  slotProps.row.settlementPrice
                    ? Number(slotProps.row.settlementPrice)
                        .toFixed(3)
                        .substring(
                          0,
                          Number(slotProps.row.settlementPrice)
                            .toFixed(3)
                            .lastIndexOf(".") + 3
                        )
                    : "0.00"
                }}
              </template>
              <template #platformCommissionRate="slotProps">
                <div style="display: flex">
                  <div style="line-height: 40px">
                    {{ Number(slotProps.row.platformCommissionRate) || 0 }}
                  </div>
                  <div style="line-height: 40px; margin-left: 10px">%</div>
                </div>
              </template>
              <template #firstNormalCommProp="slotProps">
                <div style="display: flex">
                  <div style="line-height: 40px">
                    {{ Number(slotProps.row.firstNormalCommProp) || 0 }}
                  </div>
                  <div style="line-height: 40px; margin-left: 10px">%</div>
                </div>
              </template>

              <template #platformUserCommission="slotProps">
                {{
                  slotProps.row.platformUserCommission
                    ? Number(slotProps.row.platformUserCommission)
                        .toFixed(3)
                        .substring(
                          0,
                          Number(slotProps.row.platformUserCommission)
                            .toFixed(3)
                            .lastIndexOf(".") + 3
                        )
                    : "0.00"
                }}
                <div class="line"></div>
              </template>
              <template #platformCommission="slotProps">
                {{
                  slotProps.row.platformCommission
                    ? Number(slotProps.row.platformCommission)
                        .toFixed(3)
                        .substring(
                          0,
                          Number(slotProps.row.platformCommission)
                            .toFixed(3)
                            .lastIndexOf(".") + 3
                        )
                    : "0.00"
                }}
                <div class="line"></div>
              </template>
              <template #platformProfit="slotProps">
                <div
                  :style="{
                    color:
                      Number(slotProps.row.platformProfit) < 0
                        ? '#F63C56'
                        : ' ',
                  }"
                >
                  {{
                    slotProps.row.platformProfit
                      ? Number(slotProps.row.platformProfit)
                          .toFixed(3)
                          .substring(
                            0,
                            Number(slotProps.row.platformProfit)
                              .toFixed(3)
                              .lastIndexOf(".") + 3
                          )
                      : "0.00"
                  }}
                </div>
                <div class="line"></div>
              </template>
              <template #platformProfitPrice="slotProps">
                <div
                  :style="{
                    color:
                      Number(slotProps.row.platformProfitPrice) < 0
                        ? '#F63C56'
                        : '#13CE4B',
                  }"
                >
                  {{
                    slotProps.row.platformProfitPrice
                      ? Number(slotProps.row.platformProfitPrice)
                          .toFixed(3)
                          .substring(
                            0,
                            Number(slotProps.row.platformProfitPrice)
                              .toFixed(3)
                              .lastIndexOf(".") + 3
                          )
                      : "0.00"
                  }}
                </div>
                <div class="line"></div>
              </template>
              <template #resetPriceNum="slotProps">
                {{
                  slotProps.row.resetPriceNum
                    ? slotProps.row.resetPriceNum
                    : "0"
                }}
              </template>

              <template #stock="slotProps">
                {{ slotProps.row.stock ? slotProps.row.stock : "- -" }}
              </template>
              <template #initSellNum="slotProps">
                {{
                  slotProps.row.initSellNum ? slotProps.row.initSellNum : "- -"
                }}
              </template>
              <template #skuNo="slotProps">
                {{ slotProps.row.skuNo ? slotProps.row.skuNo : "- -" }}
              </template>
              <template #status="slotProps">
                <el-switch
                  disabled
                  active-color="#2D46EE"
                  v-model="slotProps.row.status"
                  active-value="1"
                  inactive-value="0"
                  @change="onChangeSkuStatus($event, slotProps.row)"
                ></el-switch>
              </template>
              <template #bindingSkuNo="slotBindingSkuNo">
                <!-- <span v-if="slotHandSkuNo.row.handSkuNo">{{ slotHandSkuNo }}</span> -->
                <el-button
                  type="text"
                  @click="showDialogSkuVisible($event, slotBindingSkuNo)"
                  >手动绑定SKU</el-button
                >
              </template>
            </SkuForm>
          </div>
        </div>
      </div>
      <div style="margin-top: 20px">
        <el-form>
          <el-form-item label="规格说明">
            <div>
              <el-input
                placeholder="请输入规格说明"
                type="textarea"
                maxlength="200"
                show-word-limit
                :rows="3"
                style="width: 442px"
                disabled
                v-model="infoForm.specDesc"
              >
              </el-input>
            </div>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <div class="content image-text-form">
      <h3>相关推荐</h3>
      <el-form label-width="100px">
        <el-form-item label="推荐商品">
          <el-table
            :data="selectGoodsData"
            border
            :header-cell-style="{
              'text-align': 'center',
              background: '#F8F8F8',
              color: '#333333',
            }"
            :cell-style="{ 'text-align': 'center' }"
          >
            <el-table-column label="排序" width="60">
              <template slot-scope="scope">
                {{ scope.$index + 1 }}
              </template>
            </el-table-column>
            <el-table-column prop="goodsNo" label="商品编号"> </el-table-column>
            <el-table-column prop="name" label="商品名称"> </el-table-column>
            <el-table-column prop="goodsName" label="零售价">
              <template slot-scope="scope">
                {{ scope.row.minRetailPrice }}-{{ scope.row.maxRetailPrice }}
              </template>
            </el-table-column>
            <!-- <el-table-column prop="goodsName" label="操作">
              <template slot-scope="scope">
                <el-button
                  type="text"
                  style="color: red"
                  @click="deleteG(scope.$index)"
                  >删除</el-button
                >
              </template>
            </el-table-column> -->
          </el-table>
        </el-form-item>
      </el-form>
    </div>
    <div class="content bottom-but">
      <el-button type="info" @click="toOtherPages('pendingShop')"
        >返回</el-button
      >
    </div>
    <el-dialog
      title="温馨提示"
      :visible.sync="isUp"
      width="518px"
      :append-to-body="true"
    >
      <template>
        <div style="display: flex">
          <div class="info">
            <i class="el-icon-warning" style="color: red; font-size: 16px"></i>
          </div>
          <div style="margin-left: 8px; margin-top: -2px">
            <div
              class="info-item"
              v-for="(item, index) in skuFormConfig.sku"
              :key="index"
            >
              <div style="display: flex">
                <div style="color: #2d46ee">{{ item.firstGoodsSpecName }}</div>
                设置的【盈利金额】为
                <div
                  v-if="item.platformProfitPrice >= 0"
                  style="color: #13ce4b"
                >
                  {{ item.platformProfitPrice }}
                </div>
                <div v-else style="color: #f63c56">
                  {{ item.platformProfitPrice }}
                </div>
                元!
              </div>
              <div class="info-b">
                该SKU商品设定【恢复原价个数】为：{{
                  item.resetPriceNum || 0
                }}件，扣除保证金<span style="color: #f63c56">{{
                  item.resetPriceNum * item.platformProfitPrice || 0
                }}</span
                >元
              </div>
            </div>
            <div class="info-bottom">
              <div class="info-bottom-item">
                当前可用保证金余额为：<span style="color: #13ce4b">{{
                  activeEarnestMoney
                }}</span
                >元，将冻结<span style="color: #f63c56">{{
                  awaitEarnestMoney
                }}</span
                >元！
              </div>
              <div class="info-bottom-item">
                <span style="color: #f63c56">*注意：</span
                >当【恢复原价个数】已达上限，则该商品的【市场价、零售价】将自动恢复系统默认价格
              </div>
              <div
                class="info-bottom-item"
                style="color: #f63c56; font-size: 18px; font-weight: bold"
                v-if="activeEarnestMoney < 0"
              >
                保证金不足，请充值或修改商品数据！
              </div>
              <div class="info-bottom-item" v-if="activeEarnestMoney < 0">
                【保证金充值】请前往<span style="color: #2d46ee"
                  >【财务管理】-【保证金】</span
                >进行充值
              </div>
            </div>
          </div>
        </div>

        <div
          style="
            display: flex;
            justify-content: end;
            margin-top: 24px;
            margin-right: 10px;
          "
        >
          <div class="info-q" @click="isUp = false">取消</div>
          <div class="info-s" @click="verificationData">确定上架</div>
        </div>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import breadcrumbTop from '../../../components/breadcrumb.vue'
import breadcrumbSearch from '../../../components/breadcrumbSearch.vue'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'

import { quillEditor } from 'vue-quill-editor'
import Quill from 'quill'
import imageResize from 'quill-image-resize-module' // 引用
import { ImageDrop } from 'quill-image-drop-module'
Quill.register('modules/imageDrop', ImageDrop)
Quill.register('modules/imageResize', imageResize) // 注册

// import Tinymce from '@/components/Tinymce/index'
import uploadPicture from '@/components/upload/dragpicture.vue'
// import sku from "./components/sku/index"
import formFiled from '@/components/form/indexL'
import SkuForm from 'vue-sku-form'
import mixinsGoodsEdit from '../mixins/mixinsGoodsEdit.js'
import mixinsGoodsEditQuill from '../mixins/mixinsGoodsEditQuill.js'

import mixinsGiftlist from '../mixins/mixinsGiftlist.js'

import ModifyState from '../components/ModifyState.vue'

import common from '../mixins/common'
import number from '../components/number.vue'
import weight from '../components/weight.vue'
import FreeDelivery from '../components/freeDelivery.vue'
import mallPicture from '@/components/upload/mallPicture.vue'
const checkNumber = (data, index, callback) => {
  const val = data[index].stock
  // console.log(typeof val === 'number', !isNaN(val))
  console.log(typeof val === 'number' && !isNaN(val))
  if (!isNaN(val)) {
    callback()
  }
  callback(new Error('填写有误'))
}
export default {
  components: {
    breadcrumbTop,
    breadcrumbSearch,
    uploadPicture,
    formFiled,
    SkuForm,
    quillEditor,
    ModifyState,
    number,
    weight,
    FreeDelivery,
    mallPicture
  },
  data () {
    return {
      goodsName: '',
      goodsList: [
        {
          name: "测试商品",
          image: 'https://fenxiao.muruji.com/internalSystem/b2c83e66-2699-407d-bad4-c591e20827a0'
        },
        {
          name: "测试商品",
          image: 'https://fenxiao.muruji.com/internalSystem/b2c83e66-2699-407d-bad4-c591e20827a0'
        },
        {
          name: "测试商品",
          image: 'https://fenxiao.muruji.com/internalSystem/b2c83e66-2699-407d-bad4-c591e20827a0'
        },
        {
          name: "测试商品",
          image: 'https://fenxiao.muruji.com/internalSystem/b2c83e66-2699-407d-bad4-c591e20827a0'
        },

      ],
      dialogGoods: false,
      firstNormalCommProp: 0,
      goods_types: [
        {
          dictId: '1',
          dictName: '普通商品'
        },
        {
          dictId: '3',
          dictName: '赠品'
        }
      ],
      isUp: false,
      dataList: {
        list: [
          { title: '商品管理', path: '/shopManagement/pendingShop', type: '0' },
          { title: '待上架商品', path: '/shopManagement/pendingShop', type: '1' },
          { title: '查看商品', path: '', type: '2' }
        ]
      },
      searchList: {
        list: [
          { title: '商品分类', path: '', type: '0' },
          { title: '基础信息', path: '', type: '1' }
        ]
      },
      radio: 3,
      fileList: [],
      currentPageStatus: 'add', // 当前页面状态 add 添加 ， edit 编辑
      breadcrumbTitle: '新增商品',
      maxSkuNo: 1, // 通过接口获取最大 skuNo
      formFiledDataState: true, // 类目属性 状态
      skuFormConfig: {
        sourceAttribute: [], // SKU可选属性
        attribute: [], // SKU已选属性，支持 .sync 修饰符
        structure: [ // 表单结构
          {
            name: 'weight', type: 'slot', label: '重量(千克)', batch: false, required: true,

          },
          {
            name: 'image', type: 'slot', label: '规格图片', batch: false, required: true,

          },
          {
            name: 'marketPrice', type: 'slot', label: '市场价(元)', batch: false, required: true,
            validate: (data, index, callback) => {
              // console.log(data)
              const val = data[index].marketPrice
              if (!isNaN(val) && val > -1) {
                data[index].marketPrice = Number(data[index].marketPrice).toFixed(2)
                callback()
              }
              callback(new Error('填写有误'))
            }
          },
          {
            name: 'retailPrice', type: 'slot', label: '零售价(元)', batch: false, required: true,
            validate: (data, index, callback) => {
              const val = data[index].retailPrice
              if (!isNaN(val) && val > -1) {
                data[index].retailPrice = Number(data[index].retailPrice).toFixed(2)
                callback()
              }
              callback(new Error('填写有误'))
            }
          },
          {
            name: 'settlementPrice', type: 'slot', label: '结算价(元)', batch: false, required: false,

          },
          {
            name: "platformCommissionRate", type: "slot", label: "自返佣金",
            tip: '自返佣金默认比例,可自定义更改 自返佣金=【零售价】* 佣金比例', batch: false,
          },
          {
            name: "firstNormalCommProp", type: "slot", label: "一级佣金",
            tip: '一级佣金默认比例,可自定义更改 一级佣金=【零售价】* 佣金比例', batch: false,
          },
          {
            name: "platformUserCommission", type: "slot", label: "用户总佣金", width: '200px',
            tip: '用户总佣金 =自返佣金+一级佣金', batch: false
          },

          // {
          //   name: "platformCommissionRate", type: "slot", label: "佣金比例",
          //   tip: '平台用户默认佣金,可自定义更改', batch: false
          // },
          // {
          //   name: "platformUserCommission", type: "slot", label: "平台用户佣金", width: '200px',
          //   tip: '平台用户佣金 =【零售价】*【平台用户佣金比例】', batch: false
          // },
          {
            name: "platformCommission", type: "slot", label: "平台佣金",
            tip: '平台佣金 =【结算价】*【平台服务商佣金比例】', batch: false
          },
          {
            name: "platformProfit", type: "slot", label: "平台利润",
            tip: '平台利润 =【零售价】-【结算价】', batch: false
          },
          {
            name: "platformProfitPrice", type: "slot", label: "盈利金额",
            tip: ' 盈利 = 平台利润 - 平台用户佣金', batch: false
          },
          {
            name: 'resetPriceNum', type: 'slot', label: '恢复原价个数', batch: false, required: true,
            tip: '平台售卖个数达到设定个数后，原设定的【市场价】、【零售价】恢复原系统设定价格；（商品售卖出一个，则数据减少一个，实时更新）', batch: false,
            validate: (data, index, callback) => {
              const val = data[index].resetPriceNum
              if (!isNaN(val) && val > -1) {
                data[index].resetPriceNum = Number(data[index].resetPriceNum).toFixed(0)
                callback()
              }
              callback(new Error('填写有误'))
            }
          },
          {
            name: 'stock', type: 'slot', label: '库存', batch: false, required: true,
            tip: '库存为统一库存数，不可修改', batch: false,
            validate: (data, index, callback) => {
              const val = data[index].stock
              if (!isNaN(val) && val > -1) {
                data[index].stock = Number(data[index].stock).toFixed(0)
                callback()
              }
              callback(new Error('填写有误'))
            }
          },
          {
            name: 'stock', type: 'slot', label: '库存', batch: false, required: true,
            tip: '库存为商品的总库存，库存为零自动下架', batch: false,
          },
          {
            name: 'initSellNum', type: 'slot', label: '初始销量', batch: false, required: false,
            validate: (data, index, callback) => {
              const val = data[index].initSellNum
              if (!isNaN(val) && val > -1) {
                data[index].initSellNum = Number(data[index].initSellNum).toFixed(0)
                callback()
              }
              callback(new Error('填写有误'))
            }
          },
          // { name: "skuNo", type: "input", label: "SKU编码", batch: false },
          { name: 'skuNo', type: 'slot', label: 'SKU编码', batch: false },
        ],
        structure1: [ // 表单结构
          {
            name: 'weight', type: 'input', label: '重量(千克)', batch: false, required: false,
            validate: (data, index, callback) => {
              const val = data[index].weight
              if (!isNaN(val) && val > -1) {
                data[index].weight = Number(data[index].weight).toFixed(0)
                callback()
              }
              callback(new Error('填写有误'))
            }
          },
          {
            name: 'image', type: 'slot', label: '规格图片', batch: false, required: true,

          },
          {
            name: 'marketPrice', type: 'input', label: '市场价(元)', batch: false, required: true,
            validate: (data, index, callback) => {
              // console.log(data)
              const val = data[index].marketPrice
              if (!isNaN(val) && val > -1) {
                data[index].marketPrice = Number(data[index].marketPrice).toFixed(2)
                data[index].platformCommission = (data[index].settlementPrice * this.serverRate) / 100
                data[index].platformProfit = Number(data[index].retailPrice) - data[index].settlementPrice
                data[index].platformUserCommission = (data[index].retailPrice * data[index].platformCommissionRate) / 100
                data[index].platformProfitPrice = data[index].platformProfit - data[index].platformUserCommission

                callback()
              }
              callback(new Error('填写有误'))
            }
          },
          {
            name: 'retailPrice', type: 'input', label: '零售价(元)', batch: false, required: true,
            validate: (data, index, callback) => {
              const val = data[index].retailPrice
              if (!isNaN(val) && val > -1) {
                data[index].retailPrice = Number(data[index].retailPrice).toFixed(2)
                data[index].platformCommission = (data[index].settlementPrice * this.serverRate) / 100
                data[index].platformProfit = Number(data[index].retailPrice) - data[index].settlementPrice
                data[index].platformUserCommission = Math.floor(((data[index].retailPrice * data[index].platformCommissionRate) / 100) * 100) / 100 + Math.floor(((data[index].retailPrice * data[index].firstNormalCommProp) / 100) * 100) / 100
                data[index].platformProfitPrice = Number(data[index].platformProfit) - Number(data[index].platformUserCommission)

                callback()
              }
              callback(new Error('填写有误'))
            }
          },
          {
            name: 'stock', type: 'input', label: '库存', batch: false, required: true,
            tip: '库存为商品的总库存，库存为零自动下架', batch: false,
            validate: (data, index, callback) => {
              const val = data[index].stock
              if (!isNaN(val) && val > -1) {
                data[index].stock = Number(data[index].stock).toFixed(0)
                callback()
              }
              callback(new Error('填写有误'))
            }
          },
          // {
          //   name: 'stock', type: 'slot', label: '库存', batch: false, required: true,
          //   tip: '库存为统一库存数，不可修改', batch: false,
          // },
          {
            name: 'initSellNum', type: 'input', label: '初始销量', batch: false, required: false,
            validate: (data, index, callback) => {
              const val = data[index].initSellNum
              if (!isNaN(val) && val > -1) {
                data[index].initSellNum = Number(data[index].initSellNum).toFixed(0)
                callback()
              }
              callback(new Error('填写有误'))
            }
          },
          // { name: "skuNo", type: "input", label: "SKU编码", batch: false },
          { name: 'skuNo', type: 'slot', label: 'SKU编码', batch: false },
        ],
        sku: [], // SKU数据，支持 .sync 修饰符
        theme: 2, // SKU选择栏主题风格，可选1或2
        showForm: true, // 是否显示SKU选择栏  false 显示 true 隐藏
        inputValueArr: [],
        inputValueArrTemp: []
      },
      submitButtonText: '发布商品', // 提交按钮方案
      infoForm: { // 基础信息
        categoryId: '', //	是	int	类目id （数据来源：接口 - /order/comm/commodityCategory/commList）
        goodsType: '', //	是	string	商品类型（字典：goods_type）
        name: '', //	是	string	商品名称
        brandId: '', //	是	int	品牌id（数据来源：接口 - /order/comm/brand/commList?pageNo=1&pageSize=999）
        attrList: '', //	是	Object[]	商品属性组列表
        // imageList: [{url: "http://fenxiao.muruji.com/internalSystem/76c19d4d-5a0e-4ff2-9b4f-239040be1d58"}], //	是	Object[]	图片列表
        imageList: [], //	是	Object[]	图片列表
        details: '', //	否	string	详情
        specList: [], //	是	Object[]	规格列表
        skuList: [], //	是	Object[]	sku列表
        status: '', //	是	string	状态（字典分组：enable_status）
        goodsNo: '', // 商品编号
        maxPrice: '', // 最高价
        minPrice: '', // 最低价
        submitButtonText: '发布商品', // 提交按钮方案
        tagList: [],//标签
      },
      infoRules: { // 基础验证
        name: [
          { required: true, message: '请输入商品名称', trigger: 'blur' },
          { min: 1, max: 30, message: '长度在 1 到 30 个字符', trigger: 'blur' }
        ],
        brandId: [
          { required: true, message: '请选择品牌', trigger: 'change' }
        ],
        goodsType: [
          { required: true, message: '请选择类型', trigger: 'change' }
        ]
      },
      categoryIdArr: [], // 获取路由 categoryId
      categoryArrStr: '', // 回显 category
      goodsAttrDataList: [], // 类目商品属性库列表
      goodsSaleDataList: [], // 类目的销售属性列表
      goodsSaleDataListValue: [],
      goodsAttrData: [{ formconfig: {}, formData: {} }],
      formFiledData: {}, // 表单组件数 商品属性组列表
      currentStatus: 100, // 当前列表状态
      categoryList: [], // 目类列表
      brandList: [], // 品牌
      dialog: { visible: false, title: '编辑', type: '', row: {}, list: [], batch: false, titleArr: [] },
      selectionId: [], // 选 中 id
      parArray: [], // 按钮权限
      skuList: [],
      lastSkuStatus: [],
      changeGoodsStatusNum: 0,
      tagList: [],//标签
      seletedTag: [],
      dialogVisible: false,
      dialogSkuVisible: false,
      tagForm: {
        name: '',
        tagType: '1',
        tagClass: ''
      },
      labelPageNo: 1,
      labelPageSize: 10,
      labelTotalNum: 0,
      showTagDialog: false,
      tagSelectionList: [],
      bindingSkuNo: '',
      skuIndex: 0,
      editTagList: [],
      detail: {
        calculType: 0,
      },
      tableData: [],
      tableDataF: [],
      hadRechargeAmount: 0,//已充值金额
      awaitEarnestMoney: 0,//冻结金额
      activeEarnestMoney: 0,//可用金额
      serverRate: 0,
      userRate: 0
    }
  },
  mixins: [mixinsGoodsEdit, mixinsGoodsEditQuill, mixinsGiftlist, common],
  // mounted () { this.addQuillTitle() },
  created () {
    this.initialization() // 初始化 信息
    // this.getPlatInfo()
  },
  watch: {
    infoForm: {
      handler (newVal, oldVal) {

        console.log(newVal.skuList)
        this.changeGoodsStatusNum++
      },
      deep: true
    },
    skuFormConfig: {
      handler (newVal, oldVal) {
        console.log(newVal)
        newVal.sku.forEach(item => {
          item.platformCommission = (item.settlementPrice * this.serverRate) / 100
          item.platformProfit = Number(item.retailPrice) - item.settlementPrice
          item.platformCommissionRate = Number(item.platformCommissionRate || 0)
          item.firstNormalCommProp = Number(item.firstNormalCommProp || 0)
          item.platformUserCommission = Number(Math.floor(((item.retailPrice * item.platformCommissionRate) / 100) * 100) / 100) + Number(Math.floor(((item.retailPrice * item.firstNormalCommProp) / 100) * 100) / 100)
          item.platformProfitPrice = Number(item.platformProfit) - Number(item.platformUserCommission)

          // this.skuItemHandle(item)

        })
        this.$forceUpdate()
        this.skuFormConfig = newVal
        const rQuery = this.$route.query
        // console.log('skuList', this.infoForm.skuList)
        // const arr = []
        // let skuStatusNum = 0
        // newVal.sku.forEach(item => {
        //   arr.push(item.marketPrice)
        //   if (item.status === '0') { skuStatusNum++ }
        // })
        // if (newVal.sku.length === skuStatusNum) {
        //   this.infoForm.status = this.dictionaries.sale_status[0].dictName
        //   console.log(this.infoForm.status)
        //   // console.log('下')
        // }
        // if (rQuery.type === 'edit') {
        //   // this.isActionCheckGift(newVal, oldVal)
        // }
        // // this.checkGiftListBySkuId(skuIds)
        // const sortArr = arr.sort(function (a, b) { return a - b })
        // // console.log(sortArr)
        // this.infoForm.maxPrice = sortArr[sortArr.length - 1] // 最高价
        // this.infoForm.minPrice = sortArr[0] // 最低价
        this.$forceUpdate()
      },
      immediate: true,
      deep: true // 为true，表示深度监听，这时候就能监测到a值变化
    },
    // goodsSaleDataListValue (a, b) {
    //   console.log(a, b)
    //   if (this.skuFormConfig.attribute.length > 3) {
    //     this.$message({
    //       message: '规格最多只有三条',
    //       type: 'warning'
    //     })
    //     this.onChangeGoodsSaleDataListValue(b)
    //   }
    // }
  },
  computed: {},
  methods: {
    getPlatInfo () {
      this.axios.get('/sys/platformInfo', {}).then(res => {
        if (res.code == 0) {
          this.serverRate = res.data.commissionProportion
          this.userRate = res.data.platformInfo.normalCommissionProportion || 0
          this.firstNormalCommProp = res.data.platformInfo.firstNormalCommProp || 0
        }
      })
    },
    getPlatformStatistics () {
      this.axios.get('/earnestMoney/getPlatformStatistics')
        .then(res => {
          console.log(res)
          if (res.code == 0) {
            this.hadRechargeAmount = res.data.hadRechargeAmount;
            this.awaitEarnestMoney = res.data.awaitEarnestMoney;
            this.activeEarnestMoney = res.data.activeEarnestMoney;
          }
        })
    },
    upShop () {
      this.isUp = true
      this.getPlatformStatistics()
    },
    changeImage (val) {
      console.log(val)
      this.fileList = val
    },
    showDialogSkuVisible (e, scope) {
      console.log(e, scope)
      if (scope.row.bindingSkuNo) {
        this.bindingSkuNo = scope.row.bindingSkuNo
      } else {
        this.bindingSkuNo = ''
      }
      console.log(this.skuFormConfig)
      this.dialogSkuVisible = true;
      this.skuIndex = scope.$index;
    },
    bindSku () {
      if (this.bindingSkuNo == '' || this.checknumber(this.bindingSkuNo)) {
        this.$message({
          message: '请输入正确的shu编码',
          type: 'error'
        })
        return
      }
      console.log(this.skuFormConfig, this.skuIndex)
      this.dialogSkuVisible = false;
      this.skuFormConfig.sku[this.skuIndex].bindingSkuNo = this.bindingSkuNo;
      this.$forceUpdate()
      this.bindingSkuNo = '';
    },
    checknumber (String) {
      var Letters = "1234567890";
      var i;
      var c;
      for (i = 0; i < String.length; i++) {
        c = String.charAt(i);
        if (Letters.indexOf(c) == -1) {
          return true;
        }
      }
      return false;
    },

    fetchData (type) {
      this.labelPageNo = 1
      this.labelPageSize = 10
      if (type == 'reset') {
        this.$refs['tagForm'].resetFields()
        this.labelPageNo = 1
        this.labelPageSize = 10
      } else {

      }
      this.getTagList()
    },
    //选择标签
    handleSelectTag (scope) {
      //scope.row.selected==true则是已选择，执行取消操作
      if (!scope.row.selected) {
        let data = {
          id: scope.row.id,
          tagName: scope.row.tagName
        };

        this.seletedTag.push(data)
        this.tagList[scope.$index].selected = true;
      } else {

        let idx = this.seletedTag.findIndex(item => {
          return item.id == scope.row.id
        })
        this.seletedTag.splice(idx, 1)
        this.tagList[scope.$index].selected = false;
      }
      this.infoForm.tagList = this.seletedTag.map(item => {
        return item.id
      })
      console.log(this.seletedTag)
      this.$forceUpdate()
    },
    //批量选择、批量取消标签
    batchSelectTag (type) {
      if (this.tagSelectionList.length == 0) {
        this.$message({
          message: '请选择标签',
          type: 'warning',
          offset: 200
        });
        return
      }
      this.tagSelectionList.forEach(item => {
        if (type == 1) {
          item.selected = true;
        } else {
          item.selected = false;
        }

      })
      let arr = this.tagList.filter(item => item.selected).map(i => {
        if (i.selected) {
          return {
            id: i.id,
            tagName: i.tagName
          }
        }
      })
      this.seletedTag = arr;
      this.infoForm.tagList = this.seletedTag.map(item => {
        return item.id
      })
    },
    //标签多选
    handleSelectionChange (val) {
      this.tagSelectionList = val;
    },
    onSizeChange (e) {
      this.labelPageSize = e;
      this.getTagList()
    },
    onCurrentChange (e) {
      this.labelPageNo = e;
      this.getTagList()
    },
    deleteTag (idx) {
      this.tagList.forEach(item => {
        if (this.seletedTag[idx].id == item.id) {
          item.selected = false;
        }
      })
      this.seletedTag.splice(idx, 1)

      this.infoForm.tagList = this.seletedTag.map(item => {
        return item.id
      })
    },
    selectTagFn (idx) {
      if (!this.tagList[idx].select) {
        this.tagList[idx].select = !this.tagList[idx].select;
        this.seletedTag.push(this.tagList[idx])
        this.infoForm.tagList = this.seletedTag.map(item => {
          return item.id
        })
      }

    },
    //获取标签数据
    getTagList () {
      let data = {
        pageNo: this.labelPageNo,
        pageSize: this.labelPageSize
      }
      data = Object.assign(data, this.tagForm)
      this.$api.selectTagDataPage(data)
        .then(res => {
          console.log(res);
          res.data.list.forEach(item => {
            item.selected = false
          })
          this.tagList = res.data.list;
          this.seletedTag.forEach(item => {
            this.tagList.forEach(el => {
              if (item.id == el.id) {
                el.selected = true;
              }
            })
          })

          this.labelTotalNum = res.data.totalNum;
        })
        .catch(err => {
          console.log(err);
        })
    },
    //获取标签数据
    getSelectTagData () {
      this.$api.selectTagData({})
        .then(res => {
          // this.tagList = res.data;
          console.log()
          this.tagList = res.data.map(item => {
            return { tagName: item.tagName, id: item.id, select: false }
          })

        })
        .catch(err => {
          console.log(err);
        })
    },
    onChangeSkuStatus (e, row) {
      // console.log('onChangeSkuStatus', e, row)
      this.checkGift = { type: 'row', value: row }
      const skuList = this.skuList
      const nSkuIds = []
      skuList.forEach(s => {
        if (row.skuNo == s.skuNo && row.status === '0') {
          nSkuIds.push(s.id)
          this.checkGift.value['id'] = s.id
        }
      })
      if (nSkuIds.length > 0) { this.checkGiftListBySkuId(nSkuIds) }
    },
    isActionCheckGift (newVal, oldVal) {
      // const rQuery = this.$route.query
      const lastSkuStatus = this.lastSkuStatus
      const skuList = this.skuList
      const nSkuIds = []
      skuList.forEach(s => {
        newVal.sku.forEach(nItem => {
          if (nItem.status == 0 && nItem.skuNo !== '') {
            if (nItem.skuNo == s.skuNo) {
              nSkuIds.push(s.id)
            }
          }
        })
      })
      this.lastSkuStatus = nSkuIds
      console.log(nSkuIds.length, nSkuIds, lastSkuStatus.length, lastSkuStatus)
      if (nSkuIds.length > lastSkuStatus.length) {
        // this.checkGiftListBySkuId(nSkuIds)
      }
      // this.checkGiftListBySkuId (nSkuIds)
    },
    checkGiftListBySkuId (skuIds, type) {
      return new Promise((resolve, reject) => {
        this.$api.giftListBySkuId(skuIds).then((res) => {
          this.giftListByGoodId = res.data
          if (res.data.length > 0) {
            const titleArr = []
            titleArr.push(this.infoForm.name)
            if (!type) { this.showModifyState(res.data, titleArr) }
            // console.log('giftListByGoodId', res.data)
          }
          resolve(res.data)
        }).catch((err) => {
          console.log(err)
        })
      })
    },
    getButtonTreeDto () {
      // 获取权限设定
      this.limits = JSON.parse(sessionStorage.getItem('limit'))
      const params = this.limits.buttonTreeDto.filter(
        (item) => item.menuCode === 'goodsList'
      )
      params[0].buttonList.forEach((item) => {
        this.parArray.push(item.code)
      })

      // 查看成本价权限
      console.log('查看成本价权限', this.parArray.indexOf('eidt_chengbenjia'), this.parArray.indexOf('eidt_chengbenjia') != -1, this.parArray)
      if (this.parArray.indexOf('eidt_chengbenjia') === -1) {
        this.skuFormConfig.structure.forEach((item, index) => {
          if (item.name === 'costPrice') {
            this.skuFormConfig.structure.splice(index, 1)
          }
        })
      }
    },
    // 接受表单组件的数据
    dialogClick (val, state) {
      // console.log(val, state)
      this.formFiledDataState = state
      this.formFiledData = Object.assign(this.formFiledData, val)
      // console.log(this.formFiledData,'接受表单组件的数据');
    },
    getImage (val, scope) {
      console.log(val)
      console.log(this.skuFormConfig)
      // this.skuFormConfig.sku[scope.$index].Img = val
      // this.skuFormConfig.attribute[scope.$index].Img = val
      this.infoForm.skuList[scope.$index].image = val
      scope.row.image = val
      this.$refs.skuForm.validateFieldByRows(scope.$index, 'image', () => { })
    },
    // 初始化 信息
    initialization () {
      const queryObj = this.$route.query
      let category
      // 判断是否有 商品 ID 和 TYPE 类型 双从判断 当前页面状态
      // 获取商品信息 - 编辑模式
      if (queryObj.id && queryObj.type === 'edit') {
        // console.log(queryObj)
        this.getPlatInfo()
        this.getGoodInfo(queryObj.id)
        this.currentPageStatus = 'edit'
        this.submitButtonText = '修改商品'
      }
    },
    skuItemHandle (item) {
      console.log(item)
      let tempSkuName = ''; let differenceStr = ''
      if (item.secondGoodsSpecItemId && item.thirdGoodsSpecItemId) {
        tempSkuName = `${item.firstGoodsSpecItemContent},${item.secondGoodsSpecItemContent},${item.thirdGoodsSpecItemContent}`
        differenceStr = `${item.firstGoodsSpecItemId},${item.secondGoodsSpecItemId},${item.thirdGoodsSpecItemId}`
      } else if (item.secondGoodsSpecItemId) {
        tempSkuName = `${item.firstGoodsSpecItemContent},${item.secondGoodsSpecItemContent}`
        differenceStr = `${item.firstGoodsSpecItemId},${item.secondGoodsSpecItemId}`
      } else {
        tempSkuName = `${item.firstGoodsSpecItemContent}`
        differenceStr = `${item.firstGoodsSpecItemId}`
      }
      let platformUserCommission = Number(Math.floor(((item.retailPrice * item.platformCommissionRate) / 100) * 100) / 100) + Number(Math.floor(((item.retailPrice * item.firstNormalCommProp) / 100) * 100) / 100)
      let platformCommission = Number((item.settlementPrice * 10) / 100)
      let platformProfit = Number(item.retailPrice - item.settlementPrice)
      let platformProfitPrice = Number(platformProfit - platformUserCommission)
      const tempSKU = {
        id: item.id,
        sku: tempSkuName,
        difference: `${differenceStr}`,
        skuNo: item.skuNo,
        stock: item.stock,
        status: item.status,
        costPrice: item.costPrice,
        marketPrice: item.marketPrice,
        retailPrice: item.retailPrice,
        settlementPrice: item.settlementPrice,
        resetPriceNum: item.resetPriceNum,
        purchasePrice: item.purchasePrice,
        initSellNum: item.initSellNum,
        image: item.image,
        platformCommissionRate: Number(item.platformCommissionRate),
        firstNormalCommProp: Number(item.firstNormalCommProp),
        platformUserCommission: platformUserCommission,
        platformCommission: platformCommission,
        platformProfit: platformProfit,
        platformProfitPrice: platformProfitPrice,
        weight: item.weight

      }
      console.log(tempSKU)
      return tempSKU
    },
    //获取模板详情
    getTransportModel (val) {
      let data = {
        id: val
      }
      this.axios.post('/goods/shippingDetail', data)
        .then(res => {
          if (res.code == 0) {
            this.detail = res.data ? res.data : null
            this.tableData = this.detail && this.detail.regions ? this.detail.regions : []
            if (this.tableData) {
              this.tableData.forEach(item => {
                Object.assign(item, { address: item.betterAddress })
                if (item.regionJson) {
                  Object.assign(item, { addressData: JSON.parse(item.regionJson) })
                }

              })
            }

            this.tableDataF = this.detail && this.detail.freeList ? this.detail.freeList : []
            if (this.tableDataF) {
              this.tableDataF.forEach(item => {
                Object.assign(item, { address: item.betterAddress })
                Object.assign(item, { addressData: JSON.parse(item.regionJson) })
              })
            }

            this.arr = []
            if (this.detail) {
              this.arr.push(String(this.detail.isFree))
            }
            this.$forceUpdate()
          }
        })
    },
    // 获取 商品信息
    getGoodInfo (goodsId) {
      this.breadcrumbTitle = '编辑商品'
      const data = { id: goodsId }

      this.axios.post('/goods/psGet', data).then((res) => {
        console.log(res.data.skuList)
        const categoryId = res.data.categoryInfo.id
        this.infoForm = Object.assign(this.infoForm, res.data)
        this.fileList = this.infoForm.imageList
        this.selectGoodsData = res.data.recommentGoodsList || []
        // this.infoForm.brandId = res.data.brandId.toString()
        if (res.data.goodsType != 1) {
          this.skuFormConfig.structure = this.skuFormConfig.structure1
        }
        this.infoForm.freightTemplateId = res.data.freightTemplateId
        this.getTransportModel(res.data.freightModeId)
        // 回显类目ID
        this.infoForm.categoryId = categoryId
        setTimeout(() => {
          // 回显 商品类型
          if (this.dictionaries.goods_type.length !== 0) {
            const goodsTypeObj = this.dictionaries.goods_type.find(e => { return e.dictId === this.infoForm.goodsType })
            if (goodsTypeObj) { this.infoForm.goodsType = goodsTypeObj.dictName }
          }
          // 回显 上架 与 下架状态
          if (this.dictionaries.sale_status.length !== 0) {
            const statusObj = this.dictionaries.sale_status.find(e => { return e.dictId === this.infoForm.status.toString() })
            if (statusObj) { this.infoForm.status = statusObj.dictName }
          }
        }, 1000)
        // 获取 类目商品属性库列表 并 还原 展示 商品属性 表单
        this.getDataList(categoryId, res.data.attrGroupList)
        this.getCategoryList(categoryId, res.data.categoryInfoList)
        // this.getBrandList(categoryId) // 获取 品牌 列表
        // this.getSkuNo(goodsId) // 生成sku编码
        let c=JSON.parse(JSON.stringify(res.data.skuList))
        let s = []
        console.log(res.data.skuList)
        res.data.skuList.forEach(item => {
          if (item.firstGoodsSpecItemContent == null&&item.sku) {
            s.push(item.sku)
          }
        })
        console.log(s)
        if (s.length!=0) {
          this.axios.post('/goods/updateOldByPsGoodsSkuList', s).then(res => {
            if (res.code == 0) {

            }
          })
        }
        // 查询指定类目的销售属性
        this.getGoodsSaleDataList(categoryId, res.data.specList, res.data.skuList)
        if (this.infoForm.platformIdOrigin == 0) {
          this.skuFormConfig.structure.splice(12, 1)
        } else {
          this.skuFormConfig.structure.splice(13, 1)
        }
        const tempskuList = []
        res.data.skuList.forEach(e => {
          const itemHandle = this.skuItemHandle(e)
          tempskuList.push(itemHandle)
        })
        console.log(tempskuList)
        this.skuList = tempskuList
        // this.skuFormConfig.sku = this.skuList
        console.log(this.skuFormConfig)
        this.$forceUpdate()
        this.skuItemHandle()
      }).catch((err) => {
        console.log(err)
      })
    },
    // 获取类目列表
    getCategoryList (categoryInfo, categoryInfoList) {
      let data = {
        pageNo: 1,
        pageSize: 10000,
        categoryName: '',
        categoryNo: '',
        status: null
      }
      this.axios.get('/goods/categoryPageList', {
        params: data

      })
        .then(res => {
          console.log(res)
          if (res.code == 0) {
            this.categoryList = res.data.list
            this.onChangeEditClassId(categoryInfo, categoryInfoList)
          }
        })
    },
    // 获取 类目商品属性库列表 并 还原 展示 商品属性 表单
    getDataList (categoryId, attrGroupList) {
      const params = { categoryId }
      this.axios.get('/goods/attrDataList', { params: params }).then((res) => {
        const resData = res.data
        const arr = []
        // debugger
        resData.forEach(firstItem => {
          const obj = {
            name: firstItem.name,
            id: firstItem.id,
            // 表单宽度  表单的list 表单的匹配规则
            formconfig: { labeWidth: 100, itemList: [], rules: {} },
            // 表单提交数据，注：如果类型是checkbox，必须foemData里边提前声明数组
            formData: {}
          }
          firstItem.itemList.forEach(secondItem => {
            // 字典 goods_attr_type
            // 1、文本 2、单选  3、多选  4、时间
            const type = Number(secondItem.typeFlag)
            let propId
            /*
            // 修改模式下，需要多添加一个 ID
            if(this.currentPageStatus == "edit"){
              attrGroupList.forEach( aItem => {
                aItem.itemList.forEach( aItemList => {
                  if(aItem.id == firstItem.id && aItemList.id == secondItem.id){
                    propId = `value-${firstItem.id}-${secondItem.id}-${aItemList.id}`;
                  }
                })
              })
            } else {
              propId = `value-${firstItem.id}-${secondItem.id}`;
            }
            */
            propId = `value-${firstItem.id}-${secondItem.id}`
            switch (type) {
              case 1: // 文本
                obj.formconfig.itemList.push({ type: 'input', prop: propId, placeholder: '请输入内容', label: secondItem.name })
                obj.formconfig.rules = Object.assign(obj.formconfig.rules, { [propId]: [{ required: secondItem.requiredFlag != 0, message: '请输入内容', trigger: 'blur' }] })
                break
              case 2: // 单选
                const radiosArr = []
                /*
              secondItem.itemList.forEach( radiosItem => { radiosArr.push({label:radiosItem.label,value:radiosItem.id}) })
              obj.formconfig.itemList.push( { type:'radio', prop:propId, label:secondItem.name, radios:radiosArr } )
              obj.formconfig.rules = Object.assign(obj.formconfig.rules, { [propId] :[{ required: secondItem.requiredFlag == 0 ? false :true, message: '请选择内容', trigger: 'change' }]});
              */
                secondItem.itemList.forEach(item => { radiosArr.push({ label: item.label, value: item.id }) })
                obj.formconfig.itemList.push({ type: 'select', prop: propId, label: secondItem.name, option: radiosArr, isMultiple: false })
                obj.formconfig.rules = Object.assign(obj.formconfig.rules, { [propId]: [{ required: secondItem.requiredFlag != 0, message: '请选择内容', trigger: 'change' }] })
                break
              case 3: // 多选
                // debugger
                const checkboxArr = []
                /*
              secondItem.itemList.forEach( checkboxItem => { checkboxArr.push({label:checkboxItem.label,value:checkboxItem.id}) })
              obj.formconfig.itemList.push( { type:'checkbox',prop:propId,label:secondItem.name, checkboxs:checkboxArr } )
              obj.formconfig.rules = Object.assign(obj.formconfig.rules, { [propId] :[{ type: 'array', required: secondItem.requiredFlag == 0 ? false :true, message: '请至少选择一个内容', trigger: 'change' }]});
              */
                secondItem.itemList.forEach(checkboxItem => { checkboxArr.push({ label: checkboxItem.label, value: checkboxItem.id }) })
                obj.formconfig.itemList.push({ type: 'select', prop: propId, label: secondItem.name, option: checkboxArr, isMultiple: true, isCollapseTags: true })
                obj.formconfig.rules = Object.assign(obj.formconfig.rules, { [propId]: [{ required: secondItem.requiredFlag != 0, message: '请至少选择一个内容', trigger: 'blur' }] })
                // 表单提交数据，注：如果类型是checkbox，必须foemData里边提前声明数组
                // obj.formData = Object.assign(obj.formData, {[propId]:[]})
                break
              case 4: // 时间
                obj.formconfig.itemList.push({ type: 'datapicker', prop: propId, placeholder: '请选择日期', label: secondItem.name })
                obj.formconfig.rules = Object.assign(obj.formconfig.rules, { [propId]: [{ type: 'string', required: secondItem.requiredFlag != 0, message: '请选择日期', trigger: 'change' }] })
                break
              default: // 出错 - 不在设计范围
                console.log(typeof type, type)
              // 默认代码块
            }
          })
          arr.push(obj)
        })
        this.goodsAttrData = arr
        // 编辑状态下 类目属性 回显 值
        if (this.currentPageStatus === 'edit') { this.showGoodsAttrValue(arr) }
      }).catch((err) => {
        console.log(err)
      })
    },
    // 编辑状态下 类目属性 回显 值
    showGoodsAttrValue (arr) {
      const attrGroupList = this.infoForm.attrGroupList
      // const original = [...arr]
      // this.goodsAttrData[0].formData["value-15-20"] = "20"
      // 准备匹配值
      attrGroupList.forEach(firstItem => {
        firstItem.itemList.forEach(secondItem => {
          secondItem.matchValue = `value-${firstItem.id}-${secondItem.id}`
        })
      })
      this.goodsAttrData.forEach((firstItem, firstIndex) => {
        firstItem.formconfig.itemList.forEach(secondItem => {
          attrGroupList.forEach(attFirstItem => {
            attFirstItem.itemList.forEach(attSecondItem => {
              if (attSecondItem.matchValue == secondItem.prop) {
                // 1、文本 2、单选  3、多选  4、时间
                switch (attSecondItem.typeFlag) {
                  case '1': // 文本
                    // this.goodsAttrData[firstIndex].formData[attSecondItem.matchValue] = JSON.parse(attSecondItem.attrValueContent)
                    this.$set(this.goodsAttrData[firstIndex].formData, secondItem.prop, JSON.parse(attSecondItem.attrValueContent))
                    break
                  case '2': // 单选
                    // this.goodsAttrData[firstIndex].formData[attSecondItem.matchValue] = JSON.parse(attSecondItem.attrValueContent)
                    this.$set(this.goodsAttrData[firstIndex].formData, secondItem.prop, JSON.parse(attSecondItem.attrValueContent))
                    break
                  case '3': // 多选
                    // this.goodsAttrData[firstIndex].formData[attSecondItem.matchValue] = JSON.parse(attSecondItem.attrValueContent)
                    this.$set(this.goodsAttrData[firstIndex].formData, secondItem.prop, JSON.parse(attSecondItem.attrValueContent))
                    break
                  default: // 时间
                    // this.goodsAttrData[firstIndex].formData[attSecondItem.matchValue] = attSecondItem.attrValueContent
                    this.$set(this.goodsAttrData[firstIndex].formData, secondItem.prop, JSON.parse(attSecondItem.attrValueContent))
                }
              }
            })
          })
        })
      })
      // console.log(this.goodsAttrData[1].formData["value-15-20"])
    },
    // 选择销售属性
    onChangeGoodsSaleDataListValue (selectArr) {
      // sessionStorage.setItem('saleDataListValue', JSON.stringify(this.goodsSaleDataListValue))
      // this.skuFormConfig.attribute.splice(fatherIndex, 1)
      if (this.skuFormConfig.attribute.length >= 3) {
        console.log(this.skuFormConfig.attribute.length)
        console.log(selectArr.length)
        if (selectArr.length === 3) { selectArr.splice(3) }
        if (selectArr.length === 2) { selectArr.splice(2) }
        if (selectArr.length === 1) { selectArr.splice(1) }
      }
      this.goodsSaleDataListValue = selectArr
      const sourceAttribute = this.skuFormConfig.sourceAttribute
      const arr = []
      selectArr.forEach(item => {
        const matching = sourceAttribute.find(e => { return e.id === item })
        // console.log(matching)
        arr.push(matching)
      })
      const tempAttribute = []
      this.skuFormConfig.attribute.forEach(item => {
        if (item.id === undefined) {
          tempAttribute.push(item)
        }
      })
      this.skuFormConfig.attribute = tempAttribute
      // this.skuFormConfig.attribute = arr // SKU已选属性
      this.skuFormConfig.attribute = Array.from(new Set(this.skuFormConfig.attribute.concat(arr)))
      // ============== 初始 空数组，使用在添加新的属性  ==============
      this.skuFormConfig.inputValueArr = []
      this.skuFormConfig.inputValueArrTemp = []
      this.skuFormConfig.attribute.forEach((item, index) => {
        // this.skuFormConfig.inputValueArr.push({ name: '', item: [], itemList: [] })
        this.skuFormConfig.inputValueArr.push([])
        this.skuFormConfig.inputValueArrTemp.push('')
      })
      this.$nextTick(_ => {
        this.$refs.skuForm.init()
        console.log(this.skuFormConfig.inputValueArrTemp)
      })
    },
    onExceed () {
      selectArr.splice(selectArr.length - 1, 1)
      this.goodsSaleDataListValue = selectArr
      console.log('已经超出', this.goodsSaleDataListValue)
      console.log('已经超出', this.skuFormConfig.attribute)
    },
    // 查询指定类目的销售属性
    getGoodsSaleDataList (categoryId, goodsSpecList, goodsSpecTable) {
      this.skuFormConfig.sourceAttribute = [] // SKU可选属性
      // ============== 初始 回显 已选 SKU 值  ==============
      if (goodsSpecList && goodsSpecList.length !== 0) {
        goodsSpecList = goodsSpecList.sort(function (a, b) { return a.id - b.id })
        goodsSpecList.forEach(firstItem => {
          const itemArr = []
          firstItem.itemList.forEach(secondItem => {
            itemArr.push(secondItem.content)
          })
          firstItem.item = itemArr
        })
        this.skuFormConfig.attribute = goodsSpecList
        const tempSourceAttribute = Array.from(new Set(this.skuFormConfig.sourceAttribute.concat(goodsSpecList).filter(Boolean)))

        /**
         * 删除数组对象中重复的对象
         * arr: 源数组   filterField: 需要删除的重复字段，注意是字符串类型
         * 返回一个过滤好的，没有重复该字段filterField的数组
         * */
        const filterArrObj = (arr, filterField) => {
          const newArr = arr.reduce((pre, cur) => pre.some(item => item[filterField] == cur[filterField])
            ? pre : [...pre, cur], [])
          return newArr
        }
        this.skuFormConfig.sourceAttribute = filterArrObj(tempSourceAttribute, 'name')
        console.log(this.skuFormConfig)
        // const echoSpecList = []
      }

      if (goodsSpecTable && goodsSpecTable.length !== 0) {
        goodsSpecTable.forEach(item => {
          const arr = []
          arr.push(item.firstGoodsSpecItemContent)
          if (item.secondGoodsSpecItemContent) { arr.push(item.secondGoodsSpecItemContent) }
          if (item.thirdGoodsSpecItemContent) { arr.push(item.thirdGoodsSpecItemContent) }
          item.sku = arr.join(';')
          item.status = item.status.toString()
        })
        this.skuFormConfig.sku = Array.from(new Set(goodsSpecTable))
        // 还原数据时，SKU组件将 ID 过滤掉，先将 数据缓存到本地，提交数据时使用
        sessionStorage.setItem('skuFormConfigSku', JSON.stringify(goodsSpecTable))
      }
      console.log(this.skuFormConfig.sku)
      this.skuFormConfig.attribute.forEach((item, index) => {
        this.skuFormConfig.inputValueArr.push([])
        this.skuFormConfig.inputValueArrTemp.push('')
      })
      console.log('表刚刚改', this.skuFormConfig)
      this.$nextTick(_ => {
        this.$refs.skuForm.init()
        console.log(this.skuFormConfig.inputValueArrTemp)
      })
    },
    // 获取 品牌 列表
    getBrandList (categoryId) {
      const params = { pageNo: 1, pageSize: 999, categoryId }
      this.$api.brandCommList(params).then((res) => {
        this.brandList = res.data.list
        this.brandList.push({
          id: '-1',
          name: '其它'
        })
        console.log(this.brandList)
      }).catch((err) => {
        console.log(err)
      })
    },
    // 搜索 选择 类目
    onChangeCategory (val) {
      // console.log(val)
      // this.search.classId = val[val.length -1]
      // console.log(val, this.search.classId)
    },
    // 修改 回显 classId
    onChangeEditClassId (categoryIdInfo, categoryInfoList) {
      // debugger
      let categoryId
      let categoryArrStr = ''
      if (typeof categoryIdInfo === 'string') {
        categoryId = categoryIdInfo
      } else {
        categoryId = categoryIdInfo[categoryIdInfo.length - 1]
      }
      const categoryList = this.categoryList
      if (categoryList.length < 0) { console.log('categoryList没到位！', categoryList) }
      const arr = []
      categoryList.forEach((firstItem, firstIndex) => {
        if (firstItem.id === categoryId) {
          console.log(firstItem.label)
          categoryArrStr = firstItem.label
          arr.push(firstItem.id)
          return
        }
        if (firstItem.children) {
          firstItem.children.forEach((secondItem, secondIndex) => {
            if (secondItem.id === categoryId) {
              categoryArrStr = `${firstItem.label} > ${secondItem.label}`
              arr.push(firstItem.id)
              arr.push(secondItem.id)
              return
            }
            if (secondItem.children) {
              secondItem.children.forEach((thirdItem, thirdIndex) => {
                if (thirdItem.id === categoryId) {
                  categoryArrStr = `${firstItem.label} > ${secondItem.label} > ${thirdItem.label}`
                  arr.push(firstItem.id)
                  arr.push(secondItem.id)
                  arr.push(thirdItem.id)
                  return
                }
              }) // third end
            }
          }) // second end
        }
      }) // first end

      if (categoryArrStr.length == '' || categoryArrStr.length < 0) {
        if (categoryInfoList) {
          categoryInfoList.reverse()
          const tempArr = []
          categoryInfoList.forEach(item => {
            tempArr.push(item.categoryName)
          })
          categoryArrStr = tempArr.join(' > ')
          console.log(categoryArrStr)
        } else {
          console.log('还没选择商品分类1', categoryArrStr)
          this.$alert('还没选择商品分类', '提示', {
            confirmButtonText: '确定',
            callback: action => {
              console.log(action)
              this.toOtherPages('goodsCategoryEdit')
            }
          })
        }
      }
      this.categoryArrStr = categoryArrStr
    },
    // 生成sku编码
    getSkuNo (id) {
      // 主键id请求
      const params = { id }
      this.$api.gkuNoByGoodId(params).then((res) => {
        this.maxSkuNo = Number(res.data) // 获取 的 skuNo 转数字，方便后面使用可以自增
      }).catch((err) => {
        console.log(err)
      })
    },
    // 表单规则验证
    async verificationData () {
      // if (this.infoForm.name && this.infoForm.name !== '' && this.currentPageStatus === 'add') {
      const infoForm = this.infoForm
      console.log(infoForm)
      // if (infoForm.name && infoForm.name !== '') {
      //   const goodsId = infoForm.id || ''
      //   const isRepeatGoodsName = await this.checkGoodsName(infoForm.name, goodsId)
      //   // console.log('isRepeatGoodsName', isRepeatGoodsName)
      //   if (isRepeatGoodsName.code !== 0) {
      //     // this.$message.warning('商品名称有重名，请重新输入！')
      //     return console.log("商品有重名")
      //   }
      // }

      this.$refs['infoForm'].validate((valid) => {
        if (valid) {

          this.goodsAttrData.forEach(item => {
            const formName = 'formAttr' + item.id
            this.$refs[formName][0].submitForm('ruleForm')
          })
          this.$refs.skuForm.validate(valid => {
            if (valid) {
              // this.$message.success('skuForm验证通过')
              // 图片信息检查
              this.infoForm.imageList = this.fileList
              if (this.infoForm.imageList.length !== 0) {
                if (this.formFiledDataState) {
                  this.submitDate()
                } else {
                  this.$message.warning('请完善类目属性再提交！')
                }
              } else {
                this.$message.warning('请完善图片信息再提交！')
              }
            } else {
              // this.$message.warning('skuForm验证失败')
              return
            }
          })
        } else {
          this.$message.warning('请完善信息再提交！')
          console.log('error submit!!')
          return false
        }
      })
    },
    // 提交 数据
    async submitDate () {
      this.infoForm.tagList = this.seletedTag.map(item => {
        return item.id
      })
      const params = Object.assign({}, this.infoForm)
      const formFiledData = Object.assign({}, this.formFiledData) // 接受表单组件的数据
      const attrListTemp = [] 	// 商品属性组列表
      // const goodsAttrDataList = this.goodsAttrDataList // 类目商品属性库列表
      const goods_typeFindObj = this.dictionaries.goods_type.find(e => { return e.dictName === this.infoForm.goodsType })
      if (goods_typeFindObj) { params.goodsType = Number(goods_typeFindObj.dictId) }
      const statusFindObj = this.dictionaries.sale_status.find(e => { return e.dictName === this.infoForm.status })
      if (statusFindObj) { params.status = statusFindObj.dictId }
      /*
      // 接受 表单组件 的数据 整理
      attrGroupId:1,//	是	int	属性组id
      attrId:1,	//是	int	属性id
      goodsAttrItemId:1,	//否	int	属性值id（下拉）
      attrValueContent:1,//	否	String	属性值内容（日期、填空）
      */
      for (const item in formFiledData) {
        const itemTemp = item.split('-')
        const objTemp = { attrGroupId: Number(itemTemp[1]), attrId: Number(itemTemp[2]), goodsAttrItemId: Number(formFiledData[item]), attrValueContent: JSON.stringify(formFiledData[item]) }
        // console.log(itemTemp)
        attrListTemp.push(objTemp)
      }
      params.attrList = attrListTemp // 商品属性组列表
      // 规格列表
      const skuFormConfigAttribute = this.skuFormConfig.attribute
      skuFormConfigAttribute.forEach(firstItem => {
        firstItem.sort = firstItem.id ? Number(firstItem.id) : 1
        firstItem.itemList.forEach(secondItem => {
          secondItem.sort = secondItem.id ? Number(secondItem.id) : 1
        })
      })

      // 合并新添加的规格值
      skuFormConfigAttribute.forEach((firstItem, firstIndex) => {
        const inputValueArr = this.skuFormConfig.inputValueArr
        firstItem.itemList = firstItem.itemList.concat(inputValueArr[firstIndex]).filter(Boolean)
        firstItem.itemList = Array.from(new Set(firstItem.itemList))
      })
      params.specList = skuFormConfigAttribute

      const tempAttribute = this.skuFormConfig.attribute
      const skuFormConfigSku = JSON.parse(JSON.stringify(this.skuFormConfig.sku))
      console.log(skuFormConfigSku)
      skuFormConfigSku.forEach(item => {
        console.log(item.sku)
        item.sku = item.sku.split(';')
      })
      skuFormConfigSku.forEach((firstItem, firstIndex) => {
        const attributeLength = skuFormConfigAttribute.length
        firstItem.sort = 1
        firstItem.sku.forEach((secondItem, secondIndex) => {
          switch (attributeLength) {
            case 1:
              firstItem.firstGoodsSpecName = tempAttribute[0].name
              firstItem.firstGoodsSpecItemContent = firstItem.sku[0]
              break
            case 2:
              firstItem.firstGoodsSpecName = tempAttribute[0].name
              firstItem.secondGoodsSpecName = tempAttribute[1].name
              firstItem.firstGoodsSpecItemContent = firstItem.sku[0]
              firstItem.secondGoodsSpecItemContent = firstItem.sku[1]
              break
            case 3:
              firstItem.firstGoodsSpecName = tempAttribute[0].name
              firstItem.secondGoodsSpecName = tempAttribute[1].name
              firstItem.thirdGoodsSpecName = tempAttribute[2].name
              firstItem.firstGoodsSpecItemContent = firstItem.sku[0]
              firstItem.secondGoodsSpecItemContent = firstItem.sku[1]
              firstItem.thirdGoodsSpecItemContent = firstItem.sku[2]
              break
          }
        })
      })
      const currentPageStatus = this.currentPageStatus
      // 编辑时，给SKU添加ID   获取 缓存 数据 匹配 ID
      if (currentPageStatus === 'edit') {
        // console.log("页面状态", typeof currentPageStatus, currentPageStatus)
        // const skuFormConfigSkuLs = Array.from(new Set(JSON.parse(sessionStorage.getItem('skuFormConfigSku'))))
        const skuFormConfigSkuls = JSON.parse(sessionStorage.getItem('skuFormConfigSku'))
        skuFormConfigSku.forEach(item => {
          skuFormConfigSkuls.forEach(itemLs => {
            if (item.skuNo === itemLs.skuNo) {
              item.id = itemLs.id
            }
          })
        })
      }

      // 添加模式下 添加 skuNo 编号
      if (currentPageStatus === 'add') {
        skuFormConfigSku.forEach((item, index) => {
          item.skuNo = this.maxSkuNo
          item.skuNo = item.skuNo < 10 ? '0' + item.skuNo.toString() : item.skuNo.toString()
          this.maxSkuNo++
        })
      }

      // 复查 skuNo
      skuFormConfigSku.forEach((item, index) => {
        if (item.skuNo === '' || item.skuNo === undefined || item.skuNo === null) {
          // 生成sku编码
          const newSkuNo = this.maxSkuNo
          item.skuNo = newSkuNo < 10 ? '0' + newSkuNo.toString() : newSkuNo.toString()
          this.maxSkuNo++
        }
        delete item.sku
      })

      params.skuList = skuFormConfigSku
      // 图片列表 ，设置第一张图为主图
      if (params.imageList && params.imageList[0]) { params.imageList[0].mainFlag = 1 }
      // 删除多余参数属性
      delete params.maxPrice
      delete params.minPrice

      const tempGiftIdArr = []
      /**     checkGift By sku     **/
      const disableSkuArrId = []
      if (params.skuList.length > 0) {
        params.skuList.forEach(e => {
          if (e.status === '0') { disableSkuArrId.push(e.id) }
        })
      }

      if (disableSkuArrId.length > 0 && this.currentPageStatus === 'edit') {
        const giftList = await this.checkGiftListBySkuId(disableSkuArrId, 'submit')
        console.log('giftList', giftList)
        if (giftList.length > 0) {
          giftList.forEach(e => { tempGiftIdArr.push(e.id) })
        }
      }
      /**    checkGift By sku end     **/

      /**    checkGift By Goods     **/
      if (params.status === '0' && params.id) {
        const idsArr = params.id ? [params.id] : []
        const giftListG = await this.checkGiftListByGoodId(idsArr, 'submit')
        if (giftListG.length > 0) {
          giftListG.forEach(e => { tempGiftIdArr.push(e.id) })
        }
      }
      /**    checkGift By Goods end     **/

      /**    action GiftPutOff     **/
      const actionArr = Array.from(new Set(tempGiftIdArr))
      // return console.log('actionArr', actionArr)
      if (actionArr.length > 0) { await this.onGiftPutOff(actionArr) }
      /**    action GiftPutOff end     **/

      // 编辑
      delete params.attrGroupList
      delete params.categoryInfo
      delete params.goodsNo
      let data = {
        id: this.$route.query.id,
        name: params.name,
        skuList: this.skuList
      }
      this.axios.post('/goods/psWaitAddEdit', data).then((res) => {
        if (res.code === 0) {
          // this.$message({ type: 'success', message: '添加商品成功!' })
          this.$notify({
            title: '成功',
            message: '修改成功!',
            type: 'success',
            duration: 3000
          })
          this.isUp = false;
          this.toOtherPages('pendingShop')
        }
      }).catch((err) => {
        console.log(err)
        this.initialization() // 初始化 信息
      })
    }
  }
}
</script>
<style lang="scss" scoped>
@import "@/assets/styles/modifyState.scss";
::v-deep .rate .el-input__suffix {
  margin-top: 6px;
}
.line {
  width: 100%;
  height: 0px;
  border: 1px solid #c0c0cc;
  opacity: 0.5;
  margin-top: 6px;
}
.info-item {
  margin-bottom: 24px;
}
.info-bottom {
  width: 426px;
  min-height: 58px;
  background: #e9ecfe;
  opacity: 1;
  border-radius: 0px;
  .info-bottom-item {
    text-align: left;
    padding: 8px 14px;
  }
}
::v-deep.el-dialog__wrapper {
  text-align: center;
  white-space: nowrap;
  overflow: auto;
  &:after {
    content: "";
    display: inline-block;
    vertical-align: middle;
    height: 100%;
  }
  .el-dialog {
    margin: 30px auto !important;
    display: inline-block;
    vertical-align: middle;
    white-space: normal;
  }
  .el-dialog__header {
    text-align: left;
    border-bottom: none;
  }
  .info {
    font-size: 16px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    line-height: 0px;
    color: #303033;
    opacity: 1;
    text-align: left;
  }
  .info-b {
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #909099;
    opacity: 1;
    margin-top: 12px;
  }
  .info-q {
    width: 124px;
    height: 40px;
    line-height: 40px;
    background: #ffffff;
    border: 1px solid #909099;
    opacity: 1;
    border-radius: 3px;
    text-align: center;
    font-size: 16px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #909099;
    margin-right: 18px;
  }
  .info-s {
    width: 126px;
    height: 40px;
    line-height: 40px;
    background: #2d46ee;
    opacity: 1;
    border-radius: 3px;
    text-align: center;
    font-size: 16px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #ffffff;
  }
}
// .content{color: #333333!important;}
//删除全页面按钮边框
.el-button {
  border: none;
}

.image-text-form {
  .el-form {
    .el-form-item {
      &:first-child {
        .el-form-item__label {
          &:before {
            color: #ff0000;
            content: "*";
          }
        }
      }
    }
  }
}

.goods-category-edit {
  .edit-btn {
    background-color: #e3edff;
    color: #4168e7;
    font-size: 14px;
    text-align: center;
    width: 44px;
    height: 24px;
    line-height: 24px;
    border-radius: 12px;
    padding: 3px 8px;
    margin-left: 10px;
    cursor: pointer;
  }
}

.status-box {
  font-size: 16px;
  height: 40px;
  line-height: 40px;

  .list,
  .right {
    float: left;
  }

  .list {
    width: 100px;
    text-align: center;
  }

  .right {
    padding-top: 15px;
    width: calc(100% - 100px);

    .el-radio__label {
      font-size: 16px;
    }
  }
}

.bottom-but {
  margin-top: -20px;
  text-align: left;

  .el-button {
    width: 184px;
    height: 48px;
    border-radius: 4px;
    font-size: 18px;
  }

  .el-button + .el-button {
    margin-left: 32px;
  }
}

.el-select {
  border-left: 1px solid #d8dce5;
  border-right: 1px solid #d8dce5;
  border-radius: 5px;

  input[type="text"],
  input[type="number"] {
    border-radius: 0;
    border-left: none;
    border-right: none;
  }
}

.attr {
  margin-top: 0;
}

.content {
  padding-bottom: 10px !important;
}

//v1.4.0新增
.labelbox {
  display: flex;
  flex-wrap: nowrap;
  align-items: center;

  .labelitem {
    background-color: #f0f3fd;
    padding: 2px 20px;
    font-size: 14px;
    color: #4168e7;
    position: relative;
    margin-right: 20px;
    line-height: 28px;

    .labelicon {
      color: #4168e7;
      cursor: pointer;
      position: absolute;
      font-size: 16px;
      right: -6px;
      top: -6px;
    }
  }
}

.loglabelbox {
  padding: 20px 0;
  box-sizing: border-box;
  border-top: 1px solid #d9d9d9;
  border-bottom: 1px solid #d9d9d9;

  .loglabeltopbox {
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    flex-direction: row;
    border-bottom: 1px dashed #cccccc;

    .labelitem {
      background-color: #f0f3fd;
      padding: 2px 20px;
      font-size: 14px;
      color: #4168e7;
      position: relative;
      margin-right: 20px;
      margin-bottom: 14px;
      cursor: pointer;
    }

    .labelitemc {
      .labelicon {
        color: #4168e7;
        cursor: pointer;
        position: absolute;
        font-size: 16px;
        right: -6px;
        top: -6px;
      }
    }

    .notselected {
      background-color: #4168e7;
      color: #ffffff;
    }

    .selected {
      background-color: #f3f3f3;
      color: #333333;
    }
  }

  .circlebox {
    font-size: 16px;
    color: #4168e7;
    display: flex;
    margin-top: 14px;
    align-items: center;
    margin-bottom: 14px;

    .circle {
      width: 20px;
      height: 20px;
      text-align: center;
      line-height: 20px;
      border-radius: 50%;
      background-color: #4168e7;
      color: white;
      font-size: 12px;
      margin-left: 10px;
      box-sizing: border-box;
    }
  }
}

.circle1 {
  width: 10px;
  height: 10px;
  text-align: center;
  line-height: 20px;
  border-radius: 50%;
  background-color: #4168e7;
  color: white;
  font-size: 12px;
  margin-left: 10px;
  box-sizing: border-box;
  display: inline-block;
  margin-right: 4px;
}

.primary-button {
  width: 120px;
  height: 36px;
  background: #4168e7;
  border-radius: 4px;
  line-height: 36px;
  text-align: center;
  color: white;
  font-size: 16px;
  cursor: pointer;
  display: inline-block;
}
.primary-mini {
  width: 68px;
  height: 32px;
  background: #e3edff;
  border-radius: 4px;
  line-height: 32rpx;
  text-align: center;
  font-size: 16px;
  color: #4168e7;
  cursor: pointer;
  display: inline-block;
  margin-right: 20px;
}
.primary-plain {
  width: 120px;
  height: 36px;
  background: #ffffff;
  border: 1px solid #4168e7;
  border-radius: 4px;
  line-height: 36px;
  color: #4168e7;
  text-align: center;
  margin-right: 16px;
  cursor: pointer;
  display: inline-block;
}
.primary-gray {
  width: 120px;
  height: 36px;
  border: 1px solid #d9d9d9;
  border-radius: 4px;
  margin-right: 16px;
  cursor: pointer;
  display: inline-block;
  line-height: 36px;
  text-align: center;
  color: #999999;
}
#goods-edit #sku-content .sku-box .sku-content-box {
  width: calc(100% - 10px);
}
</style>
